const analytics = {
  posthog: {
    key: process.env.NEXT_PUBLIC_POSTHOG_KEY!,
    host: 'https://us.i.posthog.com',
  },
};

export default analytics;
